import { IMForm } from '@insurancemenu/imenu-components-lib';
import { colors } from '@insurancemenu/imenu-components-lib/dist/utils';
import styled from 'styled-components';

export const FormWrapperStyled = styled.div`
  box-sizing: border-box;
  width: 50%;
`;

export const ProductNameStyled = styled.p`
  font-size: 1.8rem;
  line-height: 2.4rem;
  letter-spacing: 0.03rem;
  font-weight: 700;
  margin: 0 0 3rem;
`;

export const RatesTypeTextStyled = styled.p`
  font-size: 1.4rem;
  line-height: 2rem;
  font-weight: 700;
  letter-spacing: 0.03rem;
  color: ${colors.green[600]};
  text-transform: uppercase;
  margin: 0 0 2rem;
`;

export const IMFormStyled = styled(IMForm)`
  padding: 0;
`;
